import React, { useEffect } from "react";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

import { useIdentity, useSettings, useNotifications } from "hooks";
import IdentityPresenter from "presenters/IdentityPresenter";
import fbIcon from "assets/images/account/fb-connected.png";

import Identity from "../Identity";
import PlaceholderIdentity from "../PlaceholderIdentity";

const FacebookIdentity = () => {
  const { loadIdentities, createIdentity, deleteIdentity, identities, error } = useIdentity();
  const { addErrorNotification } = useNotifications();
  const {
    settings: { fbAppId },
  } = useSettings();

  useEffect(() => {
    loadIdentities();
  }, []);

  useEffect(() => {
    if (error) {
      addErrorNotification();
    }
  }, [error]);

  const ConnectFB = () => {
    const saveFBIdentity = (response) => {
      const attr = {
        data: {
          type: "identities",
          attributes: {
            uid: response.userID,
            token: response.accessToken,
            "identity-provider": "facebook",
          },
        },
      };

      createIdentity(attr);
    };

    const connect = (response) => {
      const fbIdentity = IdentityPresenter.facebookIdentity(identities);

      if (fbIdentity === null) {
        saveFBIdentity(response);
      } else {
        deleteIdentity(IdentityPresenter.id(fbIdentity)).then(() => {
          saveFBIdentity(response);
        });
      }
    };

    return (
      <FacebookLogin
        appId={fbAppId}
        version="7.0"
        fields="name,email"
        cookie
        xfbml
        callback={connect}
        render={({ onClick }) => <Identity type="connect facebook" icon={fbIcon} action={onClick} />}
      />
    );
  };

  const DisconnectFB = () => {
    const disconnect = () => {
      const fbIdentity = IdentityPresenter.facebookIdentity(identities);

      if (fbIdentity === null) {
        return;
      }

      deleteIdentity(IdentityPresenter.id(fbIdentity));
    };

    return <Identity type="disconnect facebook" icon={fbIcon} action={disconnect} />;
  };

  return (
    <>
      {!identities && <PlaceholderIdentity type="facebook" icon={fbIcon} />}

      {identities && (IdentityPresenter.facebookIdentity(identities) ? <DisconnectFB /> : <ConnectFB />)}
    </>
  );
};

export default FacebookIdentity;
